module.exports = __webpack_public_path__ + "assets/img/426e-cw.svg";